import {atom} from "recoil";

export const loadedCreditCardsState = atom({
  key: 'loadedCreditCards',
  default: false,
  effects: []
});
